interface ColorScale {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

// Define the primary colors
const primary: ColorScale = {
  50: '#E6F6FF',
  100: '#BAE3FF',
  200: '#7CC4FA',
  300: '#47A3F3',
  400: '#2186EB',
  500: '#0967D2',  // Primary brand color
  600: '#0552B5',
  700: '#03449E',
  800: '#01337D',
  900: '#002159'
};

// Define the blue colors (for buttons and links)
const blue: ColorScale = {
  50: '#EBF8FF',
  100: '#BEE3F8',
  200: '#90CDF4',
  300: '#63B3ED',
  400: '#4299E1',
  500: '#3182CE',
  600: '#2B6CB0',
  700: '#2C5282',
  800: '#2A4365',
  900: '#1A365D'
};

interface SemanticTokens {
  colors: {
    [key: string]: {
      default: string;
      _dark?: string;
    };
  };
}

export const semanticTokens: SemanticTokens = {
  colors: {
    'background.default': {
      default: 'white',
      _dark: 'gray.800',
    },
    'background.alternate': {
      default: 'gray.50',
      _dark: 'gray.700',
    },
    'text.primary': {
      default: 'gray.800',
      _dark: 'white',
    },
    'text.secondary': {
      default: 'gray.600',
      _dark: 'gray.300',
    },
    'border.default': {
      default: 'gray.300',
      _dark: 'gray.600',
    },
    'border.input': {
      default: 'gray.400',
      _dark: 'gray.500',
    },
    'border.table': {
      default: 'gray.300',
      _dark: 'gray.600',
    },
    'border.card': {
      default: 'gray.300',
      _dark: 'gray.600',
    },
    'bg.card': {
      default: 'white',
      _dark: 'gray.700',
    },
    'bg.subtle': {
      default: 'gray.50',
      _dark: 'gray.700',
    },
    'bg.hover': {
      default: 'gray.100',
      _dark: 'gray.600',
    },
    'icon.primary': {
      default: 'blue.500',
      _dark: 'blue.300',
    },
    'link.primary': {
      default: 'blue.500',
      _dark: 'blue.300',
    },
    'text.onLight.primary': {
      default: 'gray.800',
      _dark: 'gray.800',
    },
    'text.onLight.secondary': {
      default: 'gray.700',
      _dark: 'gray.700',
    },
    'bg.input': {
      default: 'white',
      _dark: 'gray.700',
    },
    'border.hover': {
      default: 'blue.500',
      _dark: 'blue.300',
    },
  },
};

export const colors = {
  primary,
  blue,
};
